module.exports = __webpack_public_path__ + "assets/img/1-4.94f0e688.png";